/**
 * ActionButton - 決定・確定・送信など汎用アクション用ボタン
 *
 * サイズ・フォント系は上位コンポーネントから props で受け取る。
 * デフォルト値は通常の使用に合わせた値を設定してある。
 *
 * @param {string} label          - ボタンラベル
 * @param {function} onClick      - クリックハンドラ
 * @param {string} type           - ボタン種別 ('button' | 'submit' | 'reset')
 * @param {boolean} disabled      - 非活性状態にするか
 * @param {string} paddingClass   - padding クラス (例: 'px-4 py-2')
 * @param {string} textSizeClass  - font-size クラス (例: 'text-sm')
 * @param {string} colorClass     - 背景・文字色クラス (例: 'bg-blue-500 text-white')
 * @param {string} widthClass     - 幅クラス (例: 'w-full')
 */
function ActionButton({
  label,
  onClick,
  type = "button",
  disabled = false,
  paddingClass = "px-4 py-2",
  textSizeClass = "text-sm font-medium",
  colorClass = "bg-gray-100 text-black",
  widthClass = "",
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`rounded border border-gray-400 shadow-sm active:shadow-none active:translate-y-px cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed ${paddingClass} ${textSizeClass} ${colorClass} ${widthClass}`}
    >
      {label}
    </button>
  );
}

export default ActionButton;
